import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import Header from "components/Header/Header.js";
import Footer from "components/SiteFooter/Footer.js";
import HeaderLinks from "components/SiteHeader/HeaderLinks.js";
import Button from "components/CustomButtons/Button.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomDropdown from "components/CustomDropdown/CustomDropdown.js";
import Card from "components/Card/Card.js";
import Tooltip from '@material-ui/core/Tooltip';
import styles from "assets/jss/material-kit-react/views/componentsSections/javascriptStyles.js";
import GetAppIcon from '@material-ui/icons/GetApp';
import IconButton from '@material-ui/core/IconButton';
import Popover from "@material-ui/core/Popover";
import ButtonMI from "@material-ui/core/Button";

import CircularProgress from '@material-ui/core/CircularProgress';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { API_BASE_URL } from "views/api"

import './Budget.css';


import Typography from '@material-ui/core/Typography';
// import styles from "assets/jss/material-kit-react/views/landingPage.js";

// Sections for this page
import BudgetInsight from "views/MainPage/Sections/Budget.js";
// import Municipality from "views/MainPage/Sections/Municipality.js";
import Brand from "../Brand.js";

const dashboardRoutes = [];

const useStyles = makeStyles(styles);


const nameMap = {
  'districtOffice': 'जिल्ला समन्वय समिति भक्तपुर',
  'changunarayanMunicipality': 'चाँगुनारायण नगरपालिका',
  'bhaktapurMunicipality': 'भक्तपुर नगरपालिका',
  'madhyapurThimiMunicipality': 'मध्यपुर थिमि नगरपालिका',
  'suryabinayakMunicipality': 'सूर्यविनायक नगरपालिका',
}

const DCC_PROJECT_CATEGORY = {
    'local_infrastructure_development_partnership_program': 'स्थानीय पूर्वाधार विकास साझेदारी कार्यक्रम',
    'state_infrastructure_development_partnership_program': 'प्रदेश पूर्वाधार विकास साझेदारी कार्यक्रम',
    'dcc_reserve_fund': 'जी स स मौज्दात कोष तर्फका',
    'other': 'अन्य',
}

const manStyle = {
  row: { backgroundColor: '#eee', fontFamily: 'nepali-font', borderTop: '0.5px solid #999', borderBottom: '0.5px solid #999' },
  gridFix: { flexFlow: 'column' },
  btn: { width: '100%', border: 'none', padding: 0, margin: 0}
}

const OFFICE_API_MAP = {
  'districtOffice': 'bhaktapur_district',
  'changunarayanMunicipality': 'changunarayan',
  'bhaktapurMunicipality': 'bhaktapur',
  'madhyapurThimiMunicipality': 'madhyapur_thimi',
  'suryabinayakMunicipality': 'suryabinayak',
}

const administration_data = {
  offices: [
    {
      name: 'districtOffice',
      name_ne: 'जिल्ला समन्वय समिति भक्तपुर',
    },
    {
      name: 'changunarayanMunicipality',
      name_ne: 'चाँगुनारायण नगरपालिका',
    },
    {
      name: 'bhaktapurMunicipality',
      name_ne: 'भक्तपुर नगरपालिका',
    },
    {
      name: 'madhyapurThimiMunicipality',
      name_ne: 'मध्यपुर थिमी नगरपालिका',
    },
    {
      name: 'suryabinayakMunicipality',
      name_ne: 'सूर्यविनायक नगरपालिका',
    },
  ],
  api_link: {
    budget_file: (admin_unit, fiscal_year) => `${API_BASE_URL}budget/budget-file/?administrative_unit=${OFFICE_API_MAP[admin_unit]}&fiscal_year=${fiscal_year}`,
    expenditures: (admin_unit, fiscal_year) => `${API_BASE_URL}budget/expenditure/?administrative_unit=${OFFICE_API_MAP[admin_unit]}&fiscal_year=${fiscal_year}`,
    financial_managements: (admin_unit, fiscal_year) => `${API_BASE_URL}budget/financial-management/?administrative_unit=${OFFICE_API_MAP[admin_unit]}&fiscal_year=${fiscal_year}`,
    incomes: (admin_unit, fiscal_year) => `${API_BASE_URL}budget/income/?administrative_unit=${OFFICE_API_MAP[admin_unit]}&fiscal_year=${fiscal_year}`,
    intergovernmental_financial_transfers: (admin_unit, fiscal_year) => `${API_BASE_URL}budget/intergovernmental-financial-transfers/?administrative_unit=${OFFICE_API_MAP[admin_unit]}&fiscal_year=${fiscal_year}`,
    public_participations: (admin_unit, fiscal_year) => `${API_BASE_URL}budget/public-participation/?administrative_unit=${OFFICE_API_MAP[admin_unit]}&fiscal_year=${fiscal_year}`,
    revenues: (admin_unit, fiscal_year) => `${API_BASE_URL}budget/revenue/?administrative_unit=${OFFICE_API_MAP[admin_unit]}&fiscal_year=${fiscal_year}`,
    work_area_based_expenditures: (admin_unit, fiscal_year) => `${API_BASE_URL}budget/work-area-based-expenditure/?administrative_unit=${OFFICE_API_MAP[admin_unit]}&fiscal_year=${fiscal_year}`,
  }
}

const FISCAL_YEAR_STRING = {
    '1': '2075/76',
    '2': '2076/77',
    '3': '2077/78',
    '4': '2078/79',
    '5': '2079/80',
    '6': '2080/81',
    '7': '2081/82',
    '8': '2082/83',
    '9': '2083/84',
    '10': '2084/85'
}

const NEW_INCOME_CATEGORY_MAP = {
    'received_by_dcc': 'प्राप्त बजेट',

    'revenue': 'राजस्व',
    'intergovernmental_financial_transfers': 'अन्तर सरकारी वित्तीय हस्तान्तरण',
    'public_participation': 'जनसहभागिता',

    'internal_revenue': 'आन्तरिक राजस्व',
    'registration_cost': 'रजिष्ट्रेशन शुल्क',
    'revenue_sharing': 'राजस्व बाँडफाँड',
    'other_income': 'अन्य आय',

    'grant_from_gov_of_nepal': 'संघिय सरकारबाट प्राप्त अनुदान',
    'grant_from_state_gov': 'प्रदेश सरकारबाट प्राप्त अनुदान',
    'grant_from_local_level': 'अन्य स्थानीय तहबाट प्राप्त अनुदान',
    'grant_from_other_grant': 'अन्य अनुदान कार्यक्रम',

    'other': 'अन्य शिर्षक',
}

const EXPENDITURE_CATEGORY = {
    'expense_by_dcc': 'बजेट खर्च',

    'current_expenditure': 'चालु खर्च',
    'capital_expenditure': 'पूँजिगत खर्च',

    'other': 'अन्य शिर्षक',
}

const FINANCIAL_MANAGEMENT_CATEGORY = {
    'loan_investment': 'ऋण लगानी',
    'stock_investment': 'शेयर लगानी',
    'loan_received': 'ऋण प्राप्ती',

    'other': 'अन्य शिर्षक',
}


const FINANCIAL_TRANSFER_CATEGORY = {
  'grant_from_gov_of_nepal': 'नेपाल सरकारबाट प्राप्त अनुदान',
  'grant_from_state_gov': 'प्रदेश सरकारबाट प्राप्त अनुदान',
  'grant_from_local_level': 'अन्य स्थानीय तहबाट प्राप्त अनुदान',

  'other': 'अन्य शिर्षक',
}

const EXPENSE_WORK_AREA_CATEGORY = {
    'financial_development': 'आर्थिक विकास',
    'social_development': 'सामाजिक विकास',
    'infrastructure_development': 'पूर्वाधार विकास',
    'environment_and_disaster_management': 'वातावरण तथा विपद व्यवस्थापन',
    'institutional_development_service_delivery_good_governance': 'संस्थागत विकास, सेवा प्रवाह र सुशासन',

    'other': 'अन्य शिर्षक',
}

const cleanAndAdd = (array) => {
  const cleanArray = array.filter(i=>i);
  if (cleanArray.length === 0) {
    return 0
  }
  if(cleanArray.length === 1) {
    return cleanArray[0]
  }
  return cleanArray.reduce((a, b)=>parseInt(a)+parseInt(b))
}

export default function LandingPage(props) {
  const classes = useStyles();
  const { ...rest } = props;
  const [loading, setLoading] = React.useState(true);
  const [office, setOffice] = React.useState(undefined);
  const [has_hit_api, setHasEverHitAPI] = React.useState(false);
  const [selected_fiscal_year, setFiscalYear] = React.useState(undefined);
  const [fiscal_year_list, setYearList] = React.useState([]);

  const [budget_file_data, setBudgetFile] = React.useState(undefined);
  const [expenditures_data, setExpenseData] = React.useState(undefined);
  const [financial_managements_data, setFinancialMgmtData] = React.useState(undefined);
  const [incomes_data, setIncomeData] = React.useState(undefined);

  const [work_area_based_expenditures_data, setWorkAreaBasedData] = React.useState(undefined);

  const first_hit_url = `${API_BASE_URL}budget/`

  const getSetAdminUnitData = (admin_unit, yearValue) => {
    let hitting_year = undefined;
    let all_fiscal_year = [];
    const hit_url_list = [
      `${first_hit_url}budget-file/?administrative_unit=${OFFICE_API_MAP[admin_unit]}${yearValue ? `&fiscal_year=${yearValue}` : ''}`,
      `${first_hit_url}income/?administrative_unit=${OFFICE_API_MAP[admin_unit]}${yearValue ? `&fiscal_year=${yearValue}` : ''}`,
      `${first_hit_url}expenditure/?administrative_unit=${OFFICE_API_MAP[admin_unit]}${yearValue ? `&fiscal_year=${yearValue}` : ''}`,
      `${first_hit_url}financial-management/?administrative_unit=${OFFICE_API_MAP[admin_unit]}${yearValue ? `&fiscal_year=${yearValue}` : ''}`,
      `${first_hit_url}work-area-based-expenditure/?administrative_unit=${OFFICE_API_MAP[admin_unit]}${yearValue ? `&fiscal_year=${yearValue}` : ''}`,
    ];

    let initialCallCounter = 0;
    let initialDataLengthWatcher = 0;

    hit_url_list.forEach((item, i) => {
      fetch(item)
      .then(results => results.json())
      .then(data => {
        // if all data is available
        if (!(yearValue===undefined || admin_unit ===undefined)) {
          setLoading(false);
          if (i===0) setBudgetFile(data.results);
          else if (i===1) setIncomeData(data.results);
          else if (i===2) setExpenseData(data.results);
          else if (i===3) setFinancialMgmtData(data.results);
          else if (i===4) setWorkAreaBasedData(data.results);
        }

        // initial_stage  -  if year data is not available
        if (yearValue === undefined) {
          initialCallCounter = initialCallCounter + 1;
          initialDataLengthWatcher = initialDataLengthWatcher + data.results.length
          if (initialCallCounter === 5 && initialDataLengthWatcher === 0) {
            setLoading(false)
            setBudgetFile([])
            setIncomeData([])
            setExpenseData([])
            setFinancialMgmtData([])
            setWorkAreaBasedData([])
          }
          data.results.map(x => x.fiscal_year).forEach((item, i) => {
            if (item!==undefined && all_fiscal_year.indexOf(item) === -1) {
              all_fiscal_year.push(item)
              setYearList(all_fiscal_year.filter(x=>x))
              if(hitting_year !== Math.max.apply(Math, all_fiscal_year)){
                hitting_year = Math.max.apply(Math, all_fiscal_year);
                setFiscalYear(hitting_year)
                if (office === undefined) {
                  setOffice(admin_unit);
                  getSetAdminUnitData('districtOffice', hitting_year)
                } else {
                  getSetAdminUnitData(admin_unit, hitting_year)
                }
              }
            }
          });
        }



      })
    });
  }

  if (!has_hit_api) {
    setHasEverHitAPI(true);
    setLoading(true);
    setOffice('districtOffice');
    getSetAdminUnitData('districtOffice', undefined)
  }


  const clickedFiscalYear = (fiscal_year) => {
    setLoading(true);
    setFiscalYear(fiscal_year);
    getSetAdminUnitData(office, fiscal_year)
  }

  if (selected_fiscal_year === undefined && fiscal_year_list.length > 0) {
    setFiscalYear(Math.max.apply(Math, fiscal_year_list))
  }

  const officeSelected = (office) => {
    setOffice(office);
    setLoading(true);
    setYearList([])
    getSetAdminUnitData(office, undefined)
  }


  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  const id = open ? "simple-popover" : undefined;

  // income details
  let grant_data = [[], [], [], []];
  let revenue_data = [[], [], [], []];
  const other_income_data = [];
  const public_participation_data = [];
  const received_by_dcc_data = [];
  incomes_data && incomes_data.length > 0 && incomes_data.forEach((item, i) => {
    if (item.category === 'received_by_dcc') received_by_dcc_data.push(item)
    else if (item.category === 'public_participation') public_participation_data.push(item)
    else if (item.category === 'other') other_income_data.push(item)
    else if (item.category === 'grant_from_gov_of_nepal') grant_data[0].push(item)
    else if (item.category === 'grant_from_state_gov') grant_data[1].push(item)
    else if (item.category === 'grant_from_local_level') grant_data[2].push(item)
    else if (item.category === 'grant_from_other_grant') grant_data[3].push(item)
    else if (item.category === 'internal_revenue') revenue_data[0].push(item)
    else if (item.category === 'registration_cost') revenue_data[1].push(item)
    else if (item.category === 'revenue_sharing') revenue_data[2].push(item)
    else if (item.category === 'other_income') revenue_data[3].push(item)
  });

  grant_data = grant_data.map(x=>x.length === 0 ? undefined:x).filter(x=>x)
  revenue_data = revenue_data.map(x=>x.length === 0 ? undefined:x).filter(x=>x)

  const all_income_data = {
    pattern: ['data0', 'data1', 'data2', 'data3', 'data4'],
    data1: {contains_array: true, nepali_title: 'राजस्व', data: revenue_data},
    data2: {contains_array: true, nepali_title: 'अन्तर सरकारी वित्तीय हस्तान्तरण', data: grant_data},
    data0: {contains_array: false, nepali_title: 'प्राप्त बजेट', data: received_by_dcc_data},
    data3: {contains_array: false, nepali_title: 'जनसहभागिता', data: public_participation_data},
    data4: {contains_array: false, nepali_title: 'अन्य शिर्षक', data: other_income_data},
  }

  let total_income = 0
  if (incomes_data && incomes_data.length > 0 && selected_fiscal_year) total_income = cleanAndAdd(incomes_data.map(data_unit => {if ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString()) return data_unit.amount}))

  return (
    <React.Fragment>
      <div>
        <Header
          color="primary"
          routes={dashboardRoutes}
          brand=<Brand />
          shrink_brand=<Brand shrink={true} />
          rightLinks={<div><HeaderLinks /></div>}
        {...rest}
      />
      <div className={classNames(classes.main)}>
          <div className={classes.container} >
            <div style={{ color: '#333', minHeight: '80vh', padding: '30px' }}>

              {!loading && <Card style={{ paddingBottom: '30px', }}>
                <GridContainer>
                  <GridItem md={(budget_file_data && budget_file_data.length > 0) ? 5 : 7} style={{ paddingBottom: '20px', paddingTop: '20px' }}>
                    <GridContainer justify="center">
                      <span>
                        <h3 className='step intro-h3'>निकाय छान्नुहोस् : </h3>
                      </span>
                      <span>
                        <CustomDropdown
                          noLiPadding
                          buttonText=<h4>{office ? nameMap[office] : '- - - -'}</h4>
                        buttonProps={{
                        className: classes.navLink,
                        color: 'primary',
                        style: { padding: 0, margin: 0, marginLeft: '5px', paddingLeft: '5px', paddingRight: '5px', marginTop: '15px' }
                      }}
                        dropdownList={
                          administration_data.offices.map(office=>
                            <Button color="transparent" fullWidth onClick={() => officeSelected(office.name)}>
                              {office.name_ne}
                            </Button>
                          )
                          }
                      />
                </span>
                </GridContainer>
              </GridItem>
              <GridItem md={5} style={{ paddingBottom: '20px', paddingTop: '20px', textAlign: 'left' }}>
              <GridContainer justify="center">
                <span>
                  <h3 className='step intro-h3'>आर्थिक वर्ष : </h3>
                </span>
                <span>
                  <CustomDropdown
                    noLiPadding
                    buttonText=<h4 style={{ fontFamily:'nepali-font' }}>{(selected_fiscal_year && fiscal_year_list.length>0) ? FISCAL_YEAR_STRING[selected_fiscal_year] : '----/--'}</h4>
                    buttonProps={{
                      className: classes.navLink,
                      color: 'primary',
                      style: { padding: 0, margin: 0, marginLeft: '5px', paddingLeft: '5px', paddingRight: '5px', marginTop: '15px' }
                    }}
                    dropdownList={fiscal_year_list.map(fiscal_year =>
                        <Button color="transparent" fullWidth onClick={()=>clickedFiscalYear(fiscal_year)}>
                           <span style={{ fontFamily: 'nepali-font' }}>{FISCAL_YEAR_STRING[fiscal_year]}</span>
                        </Button>
                      )}
                  />
                </span>
                </GridContainer>

              </GridItem>

                {(budget_file_data && budget_file_data.length > 0) && <GridItem md={2} style={{ borderLeft: '1px solid #ddd', textAlign: 'center' }}>
                  <div style={{ paddingTop: '10px', fontWeight: 'bold', color: '#444' }}>{nameMap[office]}</div>
                  <div>
                  <IconButton aria-label="download" style={{ backgroundColor: '#eee', marginBottom: '10px' }}
                  aria-label="download"
                  style={{ backgroundColor: "#eee" }}
                  onClick={handleClick}>
                    <GetAppIcon style={{ color: '#134c7a' }} fontSize="large"/>
                  </IconButton>
                  </div>
                  <div>फाईल डाउनलोड</div>
                  <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "center"
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center"
                    }}
                  >
                    {budget_file_data.map(
                      file_object => {
                        return(
                            <a color="transparent" fullWidth href={file_object.file} download target="_blank">
                            <div style={{ padding: 10, backgroundColor: '#efefef', color: 'black', margin: 2, textAlign: 'center' }}>
                              {(file_object.name === '' || file_object.name === undefined|| file_object.name === null) ? 'फाइल' : file_object.name}
                              </div>
                            </a>
                        )
                      }
                    )}

                  </Popover>
                </GridItem>}

            </GridContainer>

                <div style={{ padding: '20px' ,fontFamily: 'nepali-font' }}>
                </div>
            {/*-----------------------------------MUNICIPALITY----------------------------------------*/}



              {fiscal_year_list.length !== 0 && selected_fiscal_year &&
              <GridContainer spacing={10} style={{ borderTop: '1px solid #ddd' }}>
                {/*-----------------------------------INCOME----------------------------------------*/}



                {/*-----------------------------------talktalk----------------------------------------*/}

                  <GridItem md={6} xs={12} sm={12} className="step grid-width" style={{ paddingTop:0 }}>
                    {incomes_data && incomes_data.length>0 && selected_fiscal_year &&
                    <div style={{ textAlign: 'center' }}>
                      <h2>
                        आय
                          <span style={{ color: '#134C7A', fontSize: '24px', paddingLeft: '10px', fontFamily: 'nepali-font' }}>
                          (रु. {total_income})
                          </span>
                      </h2>
                    </div>}
                    {all_income_data.pattern.map((unit_pattern) =>{
                      if (all_income_data[unit_pattern].contains_array) {
                        let total_sum = 0
                        all_income_data[unit_pattern].data.forEach((item, i) => {
                          item.forEach((item_j, j) => {
                            total_sum = total_sum + parseInt(item_j.amount)
                          });
                        });

                        const percentage_value = ((total_sum/total_income)*100).toFixed(2)

                        return(
                          all_income_data[unit_pattern].data.length>0 ?
                          <ExpansionPanel>
                            <ExpansionPanelSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1a-content"
                              id="panel1a-header"
                            >
                              <div className={manStyle.gridFix} style={{ width: '100%' }}>
                                <h3>
                                  {all_income_data[unit_pattern].nepali_title}
                                </h3>
                                <div style={{ width: '80%', backgroundColor: '#90bcdd', marginTop: '-10px' }}>
                                  <div style={{
                                    height: '10px',
                                    width: `${(
                                      percentage_value)}%`,
                                    backgroundColor: '#134c7a'
                                  }} />
                                </div>
                                <div style={{ color: '#134C7A', fontSize: '16px', fontFamily: 'nepali-font' }}>
                                  (रु. {total_sum} | कुल आयको {percentage_value}%)
                              </div>
                              </div>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails style={{ padding: '0px', marginBottom: '15px' }}>
                              <GridItem>
                              {all_income_data[unit_pattern].data.map( dataValue =>{
                                let total_sum_category = 0
                                dataValue.forEach((item, i) => {
                                  total_sum_category = total_sum_category + parseInt(item.amount)
                                });

                                return(
                                <GridItem style={{ marginTop: '25px', backgroundColor: '#eee' }}>
                                  <h4 style={{ paddingTop: '10px', fontFamily: 'nepali-font' }}>{NEW_INCOME_CATEGORY_MAP[dataValue[0].category]} (रु. {total_sum_category} - कुल {all_income_data[unit_pattern].nepali_title}को {((total_sum_category/total_sum)*100).toFixed(2)}%) </h4>
                                    {dataValue.map( rowEntry => {
                                      return(
                                        <Tooltip
                                          placement="top"
                                          id="tooltip-top"
                                          classes={{ tooltip: classes.tooltip }}
                                          title={`(रु. ${rowEntry.amount}) कुल ${NEW_INCOME_CATEGORY_MAP[rowEntry.category]}को ${(100 * (rowEntry.amount / total_sum_category)).toFixed(2)}%`} >
                                          <button style={manStyle.btn}>
                                            <GridContainer style={manStyle.row}>
                                              <GridItem md={5} style={{ borderRight: '1px solid #999', padding: '10px', textAlign: 'left' }}>{rowEntry && rowEntry.title}</GridItem>
                                              <GridItem md={7} style={{ padding: '10px' }}>
                                                <div
                                                  style={{
                                                    float: 'left',
                                                    width: `${(100 * (rowEntry.amount / total_sum_category))}%`,
                                                    marginTop: '5px',
                                                    height: '19px',
                                                    backgroundColor: '#134C7A',
                                                    color: 'white',
                                                    minWidth: 'fit-content',
                                                    paddingRight: '3px',
                                                    paddingLeft: '3px',
                                                }}>
                                                  {(100 * (rowEntry.amount / total_sum_category)).toFixed(2)}%
                                                </div>
                                                <div style={{ paddingTop: '5px', float:'left', marginLeft: '3px' }}>रु. {rowEntry.amount}</div>
                                              </GridItem>
                                            </GridContainer>
                                          </button>
                                        </Tooltip>
                                      )
                                    })}
                                </GridItem>
                                )})}
                              </GridItem>

                            </ExpansionPanelDetails>
                          </ExpansionPanel>
                          : <span/>
                        )
                      } else {
                        let total_sum = 0
                        all_income_data[unit_pattern].data.forEach((item, i) => {
                          total_sum = total_sum + parseInt(item.amount)
                        });
                        const percentage_value = ((total_sum/total_income)*100).toFixed(2)

                        return(
                          all_income_data[unit_pattern].data.length>0 ?
                          <ExpansionPanel>
                            <ExpansionPanelSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1a-content"
                              id="panel1a-header"
                            >
                              <div className={manStyle.gridFix} style={{ width: '100%' }}>
                                <h3>
                                  {all_income_data[unit_pattern].nepali_title}
                              </h3>
                                <div style={{ width: '80%', backgroundColor: '#90bcdd', marginTop: '-10px' }}>
                                  <div style={{
                                    height: '10px',
                                    width: `${(
                                      percentage_value)}%`,
                                    backgroundColor: '#134c7a'
                                  }} />
                                </div>
                                <div style={{ color: '#134C7A', fontSize: '16px', fontFamily: 'nepali-font' }}>
                                  (रु. {total_sum} | कुल आयको {percentage_value}%)
                              </div>
                              </div>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails style={{ padding: '0px', marginBottom: '15px' }}>
                              <GridItem>
                              {all_income_data[unit_pattern].data.map( rowEntry =>{
                                let total_sum_category = 0
                                all_income_data[unit_pattern].data.forEach((item, i) => {
                                  total_sum_category = total_sum_category + parseInt(item.amount)
                                });

                                return(
                                <GridItem style={{ backgroundColor: '#eee' }}>
                                    {
                                        <Tooltip
                                          placement="top"
                                          id="tooltip-top"
                                          classes={{ tooltip: classes.tooltip }}
                                          title={`(रु. ${rowEntry.amount}) कुल ${NEW_INCOME_CATEGORY_MAP[rowEntry.category]}को ${(100 * (rowEntry.amount / total_sum_category)).toFixed(2)}%`} >
                                          <button style={manStyle.btn}>
                                            <GridContainer style={manStyle.row}>
                                              <GridItem md={5} style={{ borderRight: '1px solid #999', padding: '10px', textAlign: 'left' }}>{rowEntry && rowEntry.title}</GridItem>
                                              <GridItem md={7} style={{ padding: '10px' }}>
                                                <div
                                                  style={{
                                                    float: 'left',
                                                    width: `${(100 * (rowEntry.amount / total_sum_category))}%`,
                                                    marginTop: '5px',
                                                    height: '19px',
                                                    backgroundColor: '#134C7A',
                                                    color: 'white',
                                                    minWidth: 'fit-content',
                                                    paddingRight: '3px',
                                                    paddingLeft: '3px',
                                                }}>
                                                  {(100 * (rowEntry.amount / total_sum_category)).toFixed(2)}%
                                                </div>
                                                <div style={{ paddingTop: '5px', float:'left', marginLeft: '3px' }}>रु. {rowEntry.amount}</div>
                                              </GridItem>
                                            </GridContainer>
                                          </button>
                                        </Tooltip>
                                    }
                                </GridItem>
                                )})}
                              </GridItem>

                            </ExpansionPanelDetails>
                          </ExpansionPanel>
                          :
                          <span/>
                        )
                      }
                      }
                    )}
                  </GridItem>
                {/*-----------------------------------talktalk----------------------------------------*/}



                {/*incomes_data && cleanAndAdd(incomes_data.map(data_unit => {if ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString()) return data_unit.amount})) !==0 &&
                <GridItem md={6} xs={12} sm={12} className="step grid-width" style={{ paddingTop:0 }}>
                  {incomes_data && incomes_data.length>0 && selected_fiscal_year &&
                  <div style={{ textAlign: 'center' }}>
                    <h2>
                      आय
                        <span style={{ color: '#134C7A', fontSize: '24px', paddingLeft: '10px', fontFamily: 'nepali-font' }}>
                        (रु. {cleanAndAdd(incomes_data.map(data_unit => {if ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString()) return data_unit.amount}))})
                        </span>
                    </h2>
                  </div>}

                  {incomes_data && incomes_data.length>0 && [...new Set(incomes_data.map(data_unit => {if ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString()) return data_unit.category}))].map(data_filtered_category =>
                    <ExpansionPanel>
                      <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <div className={manStyle.gridFix} style={{ width: '100%' }}>
                          <h3>
                            {NEW_INCOME_CATEGORY_MAP[data_filtered_category]}
                        </h3>
                          <div style={{ width: '80%', backgroundColor: '#90bcdd', marginTop: '-10px' }}>
                            <div style={{
                              height: '10px',
                              width: `${((
                                cleanAndAdd(incomes_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit.amount}))
                                /
                                cleanAndAdd(incomes_data.map(data_unit => {if ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString()) return data_unit.amount}))
                              ) * 100)}%`,
                              backgroundColor: '#134c7a'
                            }} />
                          </div>
                          <div style={{ color: '#134C7A', fontSize: '16px', fontFamily: 'nepali-font' }}>
                            {'(रु. '+
                              cleanAndAdd(incomes_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit.amount}))
                              +' | कुल आयको '+
                              ((
                                cleanAndAdd(incomes_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit.amount}))
                                /
                                cleanAndAdd(incomes_data.map(data_unit => {if ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString()) return data_unit.amount}))
                              ) * 100).toFixed(2)
                              +'%)'}
                        </div>
                        </div>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails style={{ padding: '0px', marginBottom: '15px' }}>
                        <GridItem>
                          <GridItem style={{ backgroundColor: '#eee' }}>
                            {
                              incomes_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit}).map(rowEntry =>
                                rowEntry ?
                                <Tooltip
                                  placement="top"
                                  id="tooltip-top"
                                  classes={{ tooltip: classes.tooltip }}
                                  title={`(रु. ${rowEntry.amount}) कुल ${NEW_INCOME_CATEGORY_MAP[data_filtered_category]}को ${(100 * (rowEntry.amount / cleanAndAdd(incomes_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit.amount})))).toFixed(2)}%`} >
                                  <button style={manStyle.btn}>
                                    <GridContainer style={manStyle.row}>
                                      <GridItem md={5} style={{ borderRight: '1px solid #999', padding: '10px' }}>{rowEntry && rowEntry.title}</GridItem>
                                      <GridItem md={7} style={{ padding: '10px' }}>
                                        <div
                                          style={{
                                            float: 'left',
                                            width: `${(100 * (rowEntry.amount / cleanAndAdd(incomes_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit.amount}))))}%`,
                                            marginTop: '5px',
                                            height: '19px',
                                            backgroundColor: '#134C7A',
                                            color: 'white',
                                            minWidth: 'fit-content',
                                            paddingRight: '3px',
                                            paddingLeft: '3px',
                                        }}>
                                          {(100 * (rowEntry.amount / cleanAndAdd(incomes_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit.amount})))).toFixed(2)}%
                                        </div>
                                        <div style={{ paddingTop: '5px', float:'left', marginLeft: '3px' }}>रु. {rowEntry.amount}</div>
                                      </GridItem>
                                    </GridContainer>
                                  </button>
                                </Tooltip>:<div/>
                              )
                            }
                          </GridItem>
                        </GridItem>

                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                    )}
                </GridItem>*/}

                {/*-----------------------------------EXPENDITURE----------------------------------------*/}

                {expenditures_data && expenditures_data.length>0 && cleanAndAdd(expenditures_data.map(data_unit => {if ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString()) return data_unit.amount})) !== 0 &&
                <GridItem md={6} xs={12} sm={12} className="step grid-width" style={{ paddingTop:0 }}>
                  {expenditures_data && expenditures_data.length>0 && selected_fiscal_year &&
                  <div style={{ textAlign: 'center' }}>
                      <h2>
                        व्यय
                          <span style={{ color: '#134C7A', fontSize: '24px', paddingLeft: '10px', fontFamily: 'nepali-font' }}>
                          (रु. {cleanAndAdd(expenditures_data.map(data_unit => {if ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString()) return data_unit.amount}))})
                          </span>
                      </h2>
                  </div>
                  }
                  {expenditures_data && expenditures_data.length>0 && [...new Set(expenditures_data.map(data_unit => {if ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString()) return data_unit.category}))].map(data_filtered_category =>
                    <ExpansionPanel>
                      <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <div className={manStyle.gridFix} style={{ width: '100%' }}>
                          <h3>
                            {EXPENDITURE_CATEGORY[data_filtered_category]}
                        </h3>
                          <div style={{ width: '80%', backgroundColor: '#90bcdd', marginTop: '-10px' }}>
                            <div style={{
                              height: '10px',
                              width: `${((
                                cleanAndAdd(expenditures_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit.amount}))
                                /
                                cleanAndAdd(expenditures_data.map(data_unit => {if ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString()) return data_unit.amount}))
                              ) * 100)}%`,
                              backgroundColor: '#134c7a'
                            }} />
                          </div>
                          <div style={{ color: '#134C7A', fontSize: '16px', fontFamily: 'nepali-font' }}>
                            {'(रु. '+
                              cleanAndAdd(expenditures_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit.amount}))
                              +' | कुल व्ययको '+
                              ((
                                cleanAndAdd(expenditures_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit.amount}))
                                /
                                cleanAndAdd(expenditures_data.map(data_unit => {if ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString()) return data_unit.amount}))
                              ) * 100).toFixed(2)
                              +'%)'}
                        </div>
                        </div>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails style={{ padding: '0px', marginBottom: '15px' }}>
                        <GridItem>
                          <GridItem style={{  backgroundColor: '#eee' }}>
                            {
                              expenditures_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit}).map(rowEntry =>
                                rowEntry ?
                                <Tooltip
                                  placement="top"
                                  id="tooltip-top"
                                  classes={{ tooltip: classes.tooltip }}
                                  title={`(रु. ${rowEntry.amount}) कुल ${EXPENDITURE_CATEGORY[data_filtered_category]}को ${(100 * (rowEntry.amount / cleanAndAdd(expenditures_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit.amount})))).toFixed(2)}%`} >
                                  <button style={manStyle.btn}>
                                    <GridContainer style={manStyle.row}>
                                      <GridItem md={5} style={{ borderRight: '1px solid #999', padding: '10px', textAlign: 'left' }}>{rowEntry && rowEntry.title}</GridItem>
                                      <GridItem md={7} style={{ padding: '10px' }}>
                                        <div
                                          style={{
                                            float: 'left',
                                            width: `${(100 * (rowEntry.amount / cleanAndAdd(expenditures_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit.amount}))))}%`,
                                            marginTop: '5px',
                                            height: '19px',
                                            backgroundColor: '#134C7A',
                                            color: 'white',
                                            minWidth: 'fit-content',
                                            paddingRight: '3px',
                                            paddingLeft: '3px',
                                        }}>
                                          {(100 * (rowEntry.amount / cleanAndAdd(expenditures_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit.amount})))).toFixed(2)}%
                                        </div>
                                        <div style={{ paddingTop: '5px', float:'left', marginLeft: '3px' }}>रु. {rowEntry.amount}</div>
                                      </GridItem>
                                    </GridContainer>
                                  </button>
                                </Tooltip>:<div/>
                              )
                            }
                          </GridItem>
                        </GridItem>

                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                    )}

                </GridItem>}

                {/*-----------------------------------FINANCIAL_MANAGEMENT_CATEGORY----------------------------------------*/}

                {financial_managements_data && financial_managements_data.length>0 && selected_fiscal_year && <GridItem md={12} xs={12} sm={12} style={{ borderTop: '1px solid #ddd', paddingTop:0, paddingBottom:0 }}/>}
                {financial_managements_data && cleanAndAdd(financial_managements_data.map(data_unit => {if ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString()) return data_unit.amount})) !== 0 && <>
                <GridItem md={2} xs={12} sm={12}/>
                <GridItem md={8} xs={12} sm={12} className="step grid-width" style={{ paddingTop:0 }}>
                  {financial_managements_data && financial_managements_data.length>0 && selected_fiscal_year &&
                  <div style={{ textAlign: 'center' }}>
                      <h2>
                        वित्तीय व्यवस्था
                          <span style={{ color: '#134C7A', fontSize: '24px', paddingLeft: '10px', fontFamily: 'nepali-font' }}>
                          (रु. {cleanAndAdd(financial_managements_data.map(data_unit => {if ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString()) return data_unit.amount}))})
                          </span>
                      </h2>
                  </div>
                  }
                  {financial_managements_data && financial_managements_data.length>0 && [...new Set(financial_managements_data.map(data_unit => {if ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString()) return data_unit.category}))].map(data_filtered_category =>
                    <ExpansionPanel>
                      <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <div className={manStyle.gridFix} style={{ width: '100%' }}>
                          <h3>
                            {FINANCIAL_MANAGEMENT_CATEGORY[data_filtered_category]}
                        </h3>
                          <div style={{ width: '80%', backgroundColor: '#90bcdd', marginTop: '-10px' }}>
                            <div style={{
                              height: '10px',
                              width: `${((
                                cleanAndAdd(financial_managements_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit.amount}))
                                /
                                cleanAndAdd(financial_managements_data.map(data_unit => {if ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString()) return data_unit.amount}))
                              ) * 100)}%`,
                              backgroundColor: '#134c7a'
                            }} />
                          </div>
                          <div style={{ color: '#134C7A', fontSize: '16px', fontFamily: 'nepali-font' }}>
                            {'(रु. '+
                              cleanAndAdd(financial_managements_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit.amount}))
                              +' | कुल वित्तीय व्यवस्थाको '+
                              ((
                                cleanAndAdd(financial_managements_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit.amount}))
                                /
                                cleanAndAdd(financial_managements_data.map(data_unit => {if ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString()) return data_unit.amount}))
                              ) * 100).toFixed(2)
                              +'%)'}
                        </div>
                        </div>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails style={{ padding: '0px', marginBottom: '15px' }}>
                        <GridItem>
                          <GridItem style={{  backgroundColor: '#eee' }}>
                            {
                              financial_managements_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit}).map(rowEntry =>
                                rowEntry ?
                                <Tooltip
                                  placement="top"
                                  id="tooltip-top"
                                  classes={{ tooltip: classes.tooltip }}
                                  title={`(रु. ${rowEntry.amount}) कुल ${FINANCIAL_MANAGEMENT_CATEGORY[data_filtered_category]}को ${(100 * (rowEntry.amount / cleanAndAdd(financial_managements_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit.amount})))).toFixed(2)}%`} >
                                  <button style={manStyle.btn}>
                                    <GridContainer style={manStyle.row}>
                                      <GridItem md={5} style={{ borderRight: '1px solid #999', padding: '10px', textAlign: 'left' }}>{rowEntry && rowEntry.title}</GridItem>
                                      <GridItem md={7} style={{ padding: '10px' }}>
                                        <div
                                          style={{
                                            float: 'left',
                                            width: `${(100 * (rowEntry.amount / cleanAndAdd(financial_managements_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit.amount}))))}%`,
                                            marginTop: '5px',
                                            height: '19px',
                                            backgroundColor: '#134C7A',
                                            color: 'white',
                                            minWidth: 'fit-content',
                                            paddingRight: '3px',
                                            paddingLeft: '3px',
                                        }}>
                                          {(100 * (rowEntry.amount / cleanAndAdd(financial_managements_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit.amount})))).toFixed(2)}%
                                        </div>
                                        <div style={{ paddingTop: '5px', float:'left', marginLeft: '3px' }}>रु. {rowEntry.amount}</div>
                                      </GridItem>
                                    </GridContainer>
                                  </button>
                                </Tooltip>:<div/>
                              )
                            }
                          </GridItem>
                        </GridItem>

                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                    )}

                </GridItem>
                <GridItem md={2} xs={12} sm={12}/>
                </>
              }


                {/*-----------------------------------EXPENSE_WORK_AREA_CATEGORY----------------------------------------*/}
                {work_area_based_expenditures_data && cleanAndAdd(work_area_based_expenditures_data.map(data_unit => {if ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString()) return data_unit.amount})) !==0 && selected_fiscal_year &&
                    <GridItem md={12} xs={12} sm={12} style={{ borderTop: '1px solid #ddd', paddingTop:0,paddingBottom:0, textAlign: 'center' }}>
                    <h3>कार्यक्षेत्रगत व्यय अनुमान</h3>
                    </GridItem>
                }{work_area_based_expenditures_data && cleanAndAdd(work_area_based_expenditures_data.map(data_unit => {if ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString()) return data_unit.amount})) !== 0 &&
                <>
                <GridItem md={2} xs={12} sm={12} />
                <GridItem md={8} xs={12} sm={12} className="step grid-width" style={{ paddingTop:0 }}>
                  {work_area_based_expenditures_data && work_area_based_expenditures_data.length>0 && selected_fiscal_year &&
                  <div style={{ textAlign: 'center' }}>
                      <h2>
                        कार्यक्षेत्रगत व्यय
                          <span style={{ color: '#134C7A', fontSize: '24px', paddingLeft: '10px', fontFamily: 'nepali-font' }}>
                          (रु. {cleanAndAdd(work_area_based_expenditures_data.map(data_unit => {if ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString()) return data_unit.amount}))})
                          </span>
                      </h2>
                  </div>
                  }
                  {work_area_based_expenditures_data && work_area_based_expenditures_data.length>0 && [...new Set(work_area_based_expenditures_data.map(data_unit => {if ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString()) return data_unit.category}))].map(data_filtered_category =>
                    <ExpansionPanel>
                      <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <div className={manStyle.gridFix} style={{ width: '100%' }}>
                          <h3>
                            {EXPENSE_WORK_AREA_CATEGORY[data_filtered_category]}
                        </h3>
                          <div style={{ width: '80%', backgroundColor: '#90bcdd', marginTop: '-10px' }}>
                            <div style={{
                              height: '10px',
                              width: `${((
                                cleanAndAdd(work_area_based_expenditures_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit.amount}))
                                /
                                cleanAndAdd(work_area_based_expenditures_data.map(data_unit => {if ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString()) return data_unit.amount}))
                              ) * 100)}%`,
                              backgroundColor: '#134c7a'
                            }} />
                          </div>
                          <div style={{ color: '#134C7A', fontSize: '16px', fontFamily: 'nepali-font' }}>
                            {'(रु. '+
                              cleanAndAdd(work_area_based_expenditures_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit.amount}))
                              +' | कुल कार्यक्षेत्रगत व्ययको '+
                              ((
                                cleanAndAdd(work_area_based_expenditures_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit.amount}))
                                /
                                cleanAndAdd(work_area_based_expenditures_data.map(data_unit => {if ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString()) return data_unit.amount}))
                              ) * 100).toFixed(2)
                              +'%)'}
                        </div>
                        </div>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails style={{ padding: '0px', marginBottom: '15px' }}>
                        <GridItem>
                          <GridItem style={{  backgroundColor: '#eee' }}>
                            {
                              work_area_based_expenditures_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit}).map(rowEntry =>
                                rowEntry ?
                                <Tooltip
                                  placement="top"
                                  id="tooltip-top"
                                  classes={{ tooltip: classes.tooltip }}
                                  title={`(रु. ${rowEntry.amount}) कुल ${EXPENSE_WORK_AREA_CATEGORY[data_filtered_category]}को ${(100 * (rowEntry.amount / cleanAndAdd(work_area_based_expenditures_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit.amount})))).toFixed(2)}%`} >
                                  <button style={manStyle.btn}>
                                    <GridContainer style={manStyle.row}>
                                      <GridItem md={5} style={{ borderRight: '1px solid #999', padding: '10px', textAlign: 'left' }}>{rowEntry && rowEntry.title}</GridItem>
                                      <GridItem md={7} style={{ padding: '10px' }}>
                                        <div
                                          style={{
                                            float: 'left',
                                            width: `${(100 * (rowEntry.amount / cleanAndAdd(work_area_based_expenditures_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit.amount}))))}%`,
                                            marginTop: '5px',
                                            height: '19px',
                                            backgroundColor: '#134C7A',
                                            color: 'white',
                                            minWidth: 'fit-content',
                                            paddingRight: '3px',
                                            paddingLeft: '3px',
                                        }}>
                                          {(100 * (rowEntry.amount / cleanAndAdd(work_area_based_expenditures_data.map(data_unit => {if (data_unit && ((selected_fiscal_year).toString() === (data_unit.fiscal_year).toString())) return data_unit}).map(data_unit => {if(data_unit && (data_unit.category===data_filtered_category)) return data_unit.amount})))).toFixed(2)}%
                                        </div>
                                        <div style={{ paddingTop: '5px', float:'left', marginLeft: '3px' }}>रु. {rowEntry.amount}</div>
                                      </GridItem>
                                    </GridContainer>
                                  </button>
                                </Tooltip>:<div/>
                              )
                            }
                          </GridItem>
                        </GridItem>

                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                    )}

                </GridItem>
                <GridItem md={2} xs={12} sm={12} />
                </>
              }
              </GridContainer>}

              {fiscal_year_list.length === 0 &&
              <GridItem md={12} xs={12} sm={12} style={{fontSize: 'bold', borderTop: '1px solid #ddd', borderBottom: '1px solid #ddd', padding: '20px', textAlign: 'center', fontSize: '28px'}}>
                उपलब्ध छैन
              </GridItem>}

              </Card>}
              {loading
                &&
                <Card>
                  <GridContainer>
                    <GridItem md={12} xs={12} sm={12} lg={12} style={{ textAlign: 'center', padding: '10%' }}>
                      {
                        office
                        ?
                        <h2 style={{fontFamily:"nepali-font"}}>{nameMap[office]} {selected_fiscal_year ? <span>(आ. व. <span>{FISCAL_YEAR_STRING[selected_fiscal_year]}</span>)</span>:""}</h2>
                        :
                        <h1 style={{ padding: '20px', backgroundColor: '#134c7a', color: 'white', width: 'fit-content', margin: 'auto' }}>बजेट</h1>
                      }
                      <br/>
                      <br/>
                      <br/>
                      <CircularProgress style={{ color: '#134c7a' }}/>
                    </GridItem>
                  </GridContainer>
                </Card>
              }
          </div>
        </div>

      </div>
      <Footer/>
        </div>
    </React.Fragment >
  )
}
